import Grid from '@mui/material/Grid';
import { Chart } from 'react-google-charts';

import { useMonthlySalesReportChartHook } from '../hooks/chart-hook';

const MonthlySalesReportChart = () => {
  const { resultChart, optionsGrid } = useMonthlySalesReportChartHook();

  return (
    <Grid container spacing={5}>
      <Grid item size={{ xs: 12 }}>
        <Chart
          chartType='LineChart'
          width='100%'
          height='auto'
          data={resultChart}
          options={optionsGrid}
        />
      </Grid>
    </Grid>
  );
};

export default MonthlySalesReportChart;
